import React from "react";
import PelvicSensePaidPlansCards from "./PelvicSensePaidPlansCards";
import DesktopBubbles from "../img/purple-desktop-bubbles-banner-7.png";
import TabletBubbles from "../img/purple-tablet-bubbles-banner-7.png";
import MobileBubbles from "../img/purple-mobile-bubbles-banner-7.png";

export const PelvicProgramBanner7 = ({ width }) => {
  return (
    <div className="purple-gradient-7">
      <div className="pelvic-program-banner-7" id="selectYourPlan">
        <h1 className="text-al text-black fs-banner-7-h1-48-32 text-center">
          Select your Plan
        </h1>
        <p className="text-center text-dm text-gray fs-banner-7-p-20-16 mb-5">
          Flexible plans based on your pelvic needs.
        </p>
        <p className="text-dm text-black fs-banner-7-p-20-16">
          All programs come with free bonus downloads designed to help you on
          your pelvic wellness journey. It’s time to say goodbye to pelvic pain
          and leaky bladders and HELLO to pelvic freedom!{" "}
        </p>
        <p className="text-dm text-black fs-banner-7-p-20-16 mb-4">
          Free bonus content with each plan:
        </p>
        <div className="d-flex align-items-center">
          <div className="p-0 pe-3 pb-2 pt-1">
            <div className="circle-dot dot-icon-margin"></div>
          </div>
          <p className="text-dm text-black fs-banner-7-p-20-16 m-0">
            Heal Your Pelvic Pain with Science eBook
          </p>
        </div>
        <div className="d-flex align-items-center">
          <div className="p-0 pe-3 pb-2 pt-1">
            <div className="circle-dot dot-icon-margin"></div>
          </div>
          <p className="text-dm text-black fs-banner-7-p-20-16 m-0">
            How to Handle a Flare
          </p>
        </div>
        <div className="d-flex align-items-center">
          <div className="p-0 pe-3 pb-2 pt-1">
            <div className="circle-dot dot-icon-margin"></div>
          </div>
          <p className="text-dm text-black fs-banner-7-p-20-16 m-0">
            Finding Your Pelvic Floor
          </p>
        </div>
        <div className="d-flex align-items-center">
          <div className="p-0 pe-3 pb-2 pt-1">
            <div className="circle-dot dot-icon-margin"></div>
          </div>
          <p className="text-dm text-black fs-banner-7-p-20-16 m-0">
            Medical Tests for Pelvic/Abdominal Pain
          </p>
        </div>
        <PelvicSensePaidPlansCards width={width} />
        <p className="text-gray text-dm text-center fs-warning-text-16-14-12">
          Elana and PelvicSense are not a replacement for physical therapy or
          medical advice. Please visit a healthcare professional for a diagnosis
          and treatment plan.
        </p>
      </div>
      <div>
        <img
          src={
            width > 830
              ? DesktopBubbles
              : TabletBubbles
          
          }
          className="img-fluid"
        ></img>
      </div>
    </div>
  );
};
